<template>
	<div class="special">
		<div class="special_left">
			<div class="special_left_title">地理标志产品专用标志</div>
			<div class="used_company">
				<div class="used_company_total">
					<img src="@/assets/sign/sign-5.gif" alt="">
					<div class="used_total">
						<countTo :startVal='0' :endVal='Number(detail.dbzb)' :duration='800'></countTo>
						<div>个</div>
					</div>
				</div>
				<div class="used_company_num">
					<div class="jiantou">→→→</div>
					<div class="used_title">正在被使用</div>
					<div class="used_num">
						<countTo :startVal='0' :endVal='Number(detail.syqys)' :duration='800'></countTo>
					家企业</div>
				</div>
			</div>
			<div class="classifyItem" id="fieditem">
				<img src="@/assets/sign/sign-2.png" alt="">
				<div id="fixdbtxt">
					<div class="classify_title">DB产品</div>
					<div class="classify_num">
						<countTo :startVal='0' :endVal='Number(detail.dbcp)' :duration='800'></countTo>
						个
					</div>
				</div>
			</div>
		</div>
		<div class="special_right">
			<div id="signBarCart" style="width:100%;height:1.8rem;"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				detail:'',
			}
		},
		mounted() {},
		methods:{
			getData(data){
				console.log(data)
				this.detail = data.dlbz
				this.drawCart1(data.dlbz_list);
			},
			// 专用标志
			drawCart1(list) {
				let myChart = this.$echarts.init(document.getElementById('signBarCart'));
				var option = {
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'line',
							lineStyle: {
								color: 'red'
							}
						}
					},
					textStyle: {
						color: '#fff',
					},
					grid: {
						left: '0',
						right: '0',
						bottom: '0',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data:list.map(item =>item.district),
						axisLabel: {
							interval: 0, //数据过多时不间隔显示名称
						},
						axisLine: { //X轴坐标线隐藏
							show:true,
						},
						axisTick: {		//坐标轴刻度与标签对齐
							alignWithLabel: true,
						},
					}],
					yAxis: [{
						show: false, //Y轴坐标线隐藏
						type: 'value',
						axisLabel : {   //Y轴隐藏过后产生留白
							formatter: function(){
								return "";
							}
						}
					}],
					legend: {
						icon: 'rect',
						itemWidth: 10,
						itemHeight: 10,
						itemGap: 24, // 设置间距
						right: 'center',
						data: ['使用企业数', '地标数'],
						textStyle: {
							color: '#fff',
						},
					},
					series: [
						{
							name: '使用企业数',
							type: 'bar',
							barWidth: '30%',
							barGap: '10%',
							label: { //显示数值
								show: true,
								position: 'outside',
								color: '#fff'
							},
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#C7EFF6'
									}, // 设置颜色渐变
									{
										offset: 1,
										color: '#1ED8F6'
									}
								]
							}],
							data:list.map(item =>item.syqys),
						},
						{
							name: '地标数',
							type: 'bar',
							barWidth: '30%',
							barGap: '10%',
							label: { //显示数值
								show: true,
								position: 'outside',
								color: '#fff'
							},
							color: [{
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 1,
								colorStops: [{
										offset: 0,
										color: '#EB7425'
									}, // 设置颜色渐变
									{
										offset: 1,
										color: '#EDC458'
									}
								]
							}],
							data:list.map(item =>item.dbzb),
						},
					],
				};
				myChart.setOption(option);
				window.addEventListener("resize", function() {
					myChart.resize();
				});
			},
		}
	}
</script>

<style>
</style>